import { Row, RowProps } from 'antd'

export interface KBRowProps extends RowProps {}

export function KBRow(props: KBRowProps) {
  return <Row {...props}></Row>
}
